<fixed-relative onscroll={event => onScroll(event)}>
  <script>
    export default class {
      onMounted(props, state) {
        state.element = this.root.parentElement
        state.contextTop = parseInt(window.getComputedStyle(state.element)['top'])
        state.pageTop = state.element.getBoundingClientRect().top + window.scrollY

        for (let e = state.element; e != null; e = e.parentElement) {
          e.addEventListener('scroll', event => this.onScroll(event))
        }

        window.addEventListener('scroll', event => this.onScroll(event))

        this.onScroll()
      }

      onScroll(event) {
        const viewportTop = this.state.element.getBoundingClientRect()['top']
        const scroll = window.scrollY

        const offset = scroll - (this.state.pageTop - this.state.contextTop * 2)
        const overrideTop = Math.max(this.state.contextTop, offset)

        this.state.element.style['top'] = `${overrideTop}px`
      }
    }
  </script>
</fixed-relative>